import PropTypes from 'prop-types';
import { useState } from 'react';
import {
    Box,
    IconButton,
    Typography,
    TextField,
    InputAdornment
} from '@mui/material';
import Iconify from 'src/components/iconify';

export default function AdminCardHeader({ task, taskName, onChangeTaskName, onClose }) {
    const [ isEditing, setIsEditing ] = useState(false);
    const [ editValue, setEditValue ] = useState(taskName);

    const handleStartEdit = () => {
        setIsEditing(true);
        setEditValue(taskName);
    };

    const handleSave = () => {
        if (editValue.trim() !== '') {
            onChangeTaskName(editValue);
        }
        setIsEditing(false);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSave();
        } else if (e.key === 'Escape') {
            setIsEditing(false);
            setEditValue(taskName);
        }
    };

    return (
        <Box sx={ {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
            position: 'relative'
        } }>
            { isEditing ? (
                <TextField
                    fullWidth
                    value={ editValue }
                    onChange={ (e) => setEditValue(e.target.value) }
                    onBlur={ handleSave }
                    onKeyDown={ handleKeyDown }
                    autoFocus
                    variant="outlined"
                    size="small"
                    InputProps={ {
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={ handleSave } size="small">
                                    <Iconify icon="eva:checkmark-outline" />
                                </IconButton>
                            </InputAdornment>
                        ),
                    } }
                    sx={ { mr: 3 } }
                />
            ) : (
                <Typography
                    variant="h6"
                    onClick={ handleStartEdit }
                    sx={ {
                        width: "100%",
                        padding: '3px',
                        borderRadius: "10px",
                        border: '2px solid #f0f0f0',
                        cursor: 'pointer',
                        '&:hover': {
                            bgcolor: (theme) => theme.palette.grey[ 100 ],
                            borderRadius: 1,
                            px: 1
                        },
                        px: 1
                    } }
                >
                    { taskName }
                </Typography>
            ) }

            <IconButton
                onClick={ onClose }
                sx={ { position: 'absolute', right: 0, top: 0 } }
            >
                <Iconify icon="eva:close-outline" />
            </IconButton>
        </Box>
    );
}

AdminCardHeader.propTypes = {
    task: PropTypes.object,
    taskName: PropTypes.string.isRequired,
    onChangeTaskName: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};